import { setBooleanFeatureFlagResolver } from '@atlaskit/platform-feature-flags/setBooleanFeatureFlagResolver';
import FeatureGates from '@atlaskit/feature-gate-js-client';

// Provide evaluation method through setBooleanFeatureFlagResolver to evaluate platform feature gates
export const setPlatformFeatureFlagResolver = (): void => {
	setBooleanFeatureFlagResolver((key) => {
		return FeatureGates.checkGate(key);
	});
};
